<template>
	<div class="">
    <div class="header_bg pr">
       <div>
          <div class="flex flex-center pt-20">
					  <div class="text-center c7 ptv-32 fitre">
							<img class="wh_24_17 m0-auto mb-5" src="../../assets/img/icon/rank2.png" alt="">
							<div class="wh_68 bg_CE b-radius-50 pr">
								<van-image :src="data[1]?data[1].avatar:''" :lazy-load="true">
									<template v-slot:error>
										<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
									</template>
								</van-image>
							</div>
							<div class="mtb-10 fz-14 fw-500 l-h-14 w68 text-hide">{{data[1]?data[1].net_name:'暂无'}}</div>
							<div class="fen_sty m0-auto">{{data[1]?data[1].score:0}}分</div>
						</div>
						<div class="text-center c7 mlr-37 fitre midd">
							<img class="wh_24_17 m0-auto mb-5" src="../../assets/img/icon/rank1.png" alt="">
							<div class="wh_82 bg_FE b-radius-50 pr" >
								<van-image :src="data[0]?data[0].avatar:''" :lazy-load="true">
									<template v-slot:error>
										<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
									</template>
								</van-image>
							</div>
							<div class="mtb-10 fz-14 fw-500 l-h-14 w82 text-hide">{{data[0]?data[0].net_name:'暂无'}}</div>
							<div class="fen_sty m0-auto">{{data[0]?data[0].score:0}}分</div>
						</div>
						<div class="text-center c7 ptv-32 fitre">
							<img class="wh_24_17 m0-auto mb-5" src="../../assets/img/icon/rank3.png" alt="">
							<div class="wh_68 bg_FC b-radius-50 pr">
								<van-image :src="data[2]?data[2].avatar:''" :lazy-load="true">
									<template v-slot:error>
										<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
									</template>
								</van-image>
							</div>
							<div class="mtb-10 fz-14 fw-500 l-h-14 w68 text-hide">{{data[2]?data[2].net_name:'暂无'}}</div>
							<div class="fen_sty m0-auto">{{data[2]?data[2].score:0}}分</div>
						</div>
				  </div>

					<div class="flex flex-center pr">
						<div class="com_vip">2</div>
						<div class="center_vip">1</div>
						<div class="com_vip ml-61 pl-80">3</div>
					</div>
       </div>

			 <div class="vip_main ptlr-20-29-25 box-s list_img" :style="{height: height }">
         <div class="flexs flex-jus mb-20" v-for="(item, index) in list" :key="index">
					 <div class="flexs">
             <div class="c2 fz-15">{{index + 4}}</div>
						 <van-image :src="item.avatar" :lazy-load="true">
							<template v-slot:error>
								<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
							</template>
						</van-image>
             <div class="fz-16 c1 fw-500 w167 text-hide">{{item.net_name}}</div>
					 </div>
					 <div class=" c1 fz-15 fw-600">
            {{item.score}}分
					 </div>
				 </div>
			 </div>

			 <div class="self flex-jus flexs plr-15 box-s c7 list_img">
         <div class="flexs">
            <div class="fz-15">{{self.orderly}}</div>
						 <van-image :src="self.avatar" :lazy-load="true">
								<template v-slot:error>
									<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
								</template>
					  	</van-image>
             <div class="fz-16 fw-500 w167 text-hide">{{self.net_name}}</div>
					 </div>
					 <div class=" fz-15 fw-600">
            {{self.score}}分
					 </div>
			 </div>
    </div>
		<!-- <noData v-if="show" style="top: 65%"></noData> -->
		<loading :loadFlag="loadFlag"></loading>		
	</div>
</template>
<script>
  import noData from "@/components/noData"
  import loading from "@/components/loading"
	import { matchRanking } from '@/api/api'
	export default {
		components: {
			noData,
			loading
		},
		data() {
			return {
        list: [],
				height: '',
				data: [],
				show:false,
				loadFlag: false,
				self: {}
			};
		},
		created() {
      this.initData()
		},
		mounted(){
			this.$nextTick(()=>{
        // this.height = () * (document.documentElement.clientWidth / 375)
        // this.height = (document.body.clientHeight - 289) * (document.documentElement.clientWidth / 375) + 'px'
			})
		},
		methods: {
			// this.$route.query.other_id
			async initData(){
				this.loadFlag = true
				const res = await matchRanking({ mtc_id: this.$route.query.mtc_id, ts_id: this.$route.query.ts_id })
				this.loadFlag = false
				if(res.code == 1000){
          this.list = res.data.list.splice(3)
					this.self = res.data.self
					if(this.list.length == 0){
            this.show = true
					}
					this.data = res.data.list.splice(0,3)
				} else {
					this.$toast(res.msg)
				}
			}

		}
	};
</script>
<style lang="less" scoped>
.header_bg {
  width: 100%;
  height: 332px;
  background: linear-gradient(180deg, #465CE6 0%, #1D47B0 100%);
  box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.02);
}

.fen_sty {
	width: 70px;
	height: 23px;
	line-height: 23px;
	background: rgba(255, 255, 255, 0.3);
	border-radius: 12px;
	font-size: 16px;
  font-weight: 600;
}

.com_vip {
	width: 137px;
	height: 189px;
	background: linear-gradient(90deg, #5377FF 0%, #3B62FF 100%);
	box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.02);
	border-radius: 12px;
	font-size: 24px;
	font-weight: 600;
	color: #E4E4FF;
	padding: 13px 0 0 42px ;
	box-sizing: border-box;
	margin-top: 14px;
}

.center_vip {
	position: absolute;
	left: 50%;
	top: -4px;
	transform: translateX(-50%);
	width: 137px;
	height: 189px;
	background: #528AFF;
	box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.02);
	border-radius: 12px;
	font-size: 30px;
	font-weight: 600;
	color: #FFFFFF;
	text-align: center;
	padding-top: 15px;
	box-sizing: border-box;
}

.vip_main {
	position: fixed;
	top: 259px;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: auto;
	background: #FFFFFF;
	box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.02);
	border-radius: 20px 20px 0 0;
}

.vip_main::-webkit-scrollbar{
	display: none;
}

.self {
	position: fixed;
	bottom: 25px;
	left: 10px;
	right: 10px;
	height: 64px;
	background: #497CFF;
  border-radius: 15px;
}

/deep/.fitre .van-image {
  width: 62px;
	height: 62px;
	border-radius: 50%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

/deep/ .midd .van-image{
  width: 75px;
	height: 75px;
}

/deep/.list_img .van-image{
  width: 40px;
	height: 40px;
	margin: 0 23px 0 12px;
	border-radius: 50%;
}

/deep/.van-image__img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}

/deep/.van-image__error {
  width: 100%;
	height: 100%;
	border-radius: 50%;
}

/deep/.van-image__loading {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
</style>
